import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoadingIndicatorService {

    private workload = 0;
    private _loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public readonly IsLoading: Observable<boolean> = this._loading.asObservable();

    public StartWork(): void {
        this.workload++;
        this._loading.next(this.workload > 0);
    }

    public EndWork(): void {
        this.workload--;
        this._loading.next(this.workload > 0);
    }
}
